module.exports = __webpack_public_path__ + "img/dontDo.6fb5ba7b.svg";